export const genderRenderer = (gender: string) => {
  switch ((gender ?? '').toLowerCase()) {
    case 'male':
      return 'Pria';
    case 'female':
      return 'Wanita';
    default:
      return '';
  }
};
